import {SaveConfigurationDataDto} from 'Core/Components/Controls/ProductConfigurator/Pages/StartPage/Stores/Params/SaveConfigurationDataDto';

export class SaveAllConfigurationDataDto {
    constructor(public SaveConfigurationDataDtos: Array<SaveConfigurationDataDto>) {
    }
}